import { Card, Flex, Table, Typography } from "antd";
import type { ColumnType } from "antd/lib/table";
import { ImpressaoContainer, ImpressaoHeader } from "components/Impressao";
import { useMemo } from "react";
import { decimalFormater } from "std/format";
import { roundAbnt } from "std/math";
import styled from "styled-components";
import type { TApiColetasCidade, TApiColetasCidadeItem } from ".";

const { Title } = Typography;

const FlexStyled = styled(Flex)`
   h5.ant-typography { 
        margin: 0px;
        font-weight: bold !important;
    }
`;

export const columns: ColumnType<TApiColetasCidadeItem>[] = [
	{
		title: "Código",
		dataIndex: ["produtor", "for_codigoindividual"],
		key: "for_codigoindividual",
		render: (for_codigoindividual) => <>{for_codigoindividual || ""}</>,
	},
	{
		title: "Produtor",
		dataIndex: ["produtor", "pessoa", "pes_nome_razaosocial"],
		key: "pes_nome_razaosocial",
		render: (produtor) => <>{produtor || ""}</>,
	},
	{
		title: "Transportador",
		dataIndex: ["coleta", "transportador", "pessoa", "pes_nome_razaosocial"],
		key: "transportador",
		render: (transportador) => <>{transportador || ""}</>,
	},
	{
		title: "Produto",
		dataIndex: "produtoNome",
		key: "produtoNome",
	},
	{
		title: "Quantidade",
		dataIndex: "quantidade",
		key: "quantidade",
		align: "right",
		render: (volume) => <>{volume || ""}</>,
	},
];

export function TableRelColetasCidade({ data, title }: { data: TApiColetasCidade[] | undefined; title: string }) {
	const totalVolumeGeral = useMemo(
		() =>
			roundAbnt((data || []).reduce((acc, cur) => acc + roundAbnt((cur?.coletas || []).reduce((acc2, cur2) => acc2 + cur2.quantidade, 0)), 0)),
		[data],
	);

	const totalRegistrosGeral = useMemo(() => roundAbnt((data || []).reduce((acc, cur) => acc + cur?.coletas?.length || 0, 0)), [data]);

	return (
		<ImpressaoContainer className="w-full mt-3" title={title}>
			<ImpressaoHeader title={title} />

			<Flex vertical={true} gap={"12px"} style={{ width: "100%" }}>
				{data &&
					data.length > 0 &&
					data.map((cidade) => {
						const totalVolume = roundAbnt((cidade?.coletas || []).reduce((acc, cur) => acc + cur.quantidade, 0));

						return (
							<Card key={cidade.cid_idpk}>
								<Title level={4} style={{ fontWeight: "bold" }}>
									Cidade: {cidade?.cid_cidade || ""}
								</Title>
								<Table
									rowKey="cid_idpk"
									columns={columns}
									dataSource={cidade?.coletas || []}
									pagination={false}
									size="small"
									rowClassName="zebra"
									summary={(rows) => (
										<Table.Summary.Row>
											<Table.Summary.Cell index={0} align="left">
												<Flex gap={"12px"}>
													<Title level={5}>Registros:</Title>
													<Title
														level={5}
														style={{
															margin: "0px",
															textAlign: "right",
														}}
													>
														{rows?.length || 0}
													</Title>
												</Flex>
											</Table.Summary.Cell>

											<Table.Summary.Cell index={1} colSpan={4} align="right">
												<Flex gap={"12px"} justify="end">
													<Title level={5}>Quantidade:</Title>
													<Title level={5} style={{ margin: "0px" }}>
														{decimalFormater(totalVolume)}
													</Title>
												</Flex>
											</Table.Summary.Cell>
										</Table.Summary.Row>
									)}
								/>
							</Card>
						);
					})}
			</Flex>

			<Flex justify="space-between" style={{ width: "100%", marginTop: "18px" }}>
				<FlexStyled gap={"12px"}>
					<Title level={4}>Total de Registros:</Title>
					<Title
						level={4}
						style={{
							margin: "0px",
						}}
					>
						{decimalFormater(totalRegistrosGeral || 0)}
					</Title>
				</FlexStyled>

				<FlexStyled gap={"12px"}>
					<Title level={4}>Quantidade Total:</Title>
					<Title level={4} style={{ margin: "0px" }}>
						{decimalFormater(totalVolumeGeral || 0)}
					</Title>
				</FlexStyled>
			</Flex>
		</ImpressaoContainer>
	);
}
